/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable implicit-arrow-linebreak */
import React from 'react'
import { useTranslation } from 'react-i18next'
import Link from '../link'
import WithAuth from '../withAuth'
import Search from '../search'
import combineClassNames from '../../helpers/combineClassNames'
import {
  useMobileMenu,
} from '../../hook'
import { useThemeConfig } from '../../hook/use-theme-config'
import { useSystemSettings } from '../../vendor/react-omnitech-api'
import useStyles from './menu-mobil-style'
import Accordion from '../accordion'
import ButtonLanguage from './button-language'

const MenuMobileView = ({
  onMemberCodeOpen,
  onLanguageChange,
  availableLocales,
  currentLocale,
  // isOpenSearch,
  onCouponMarketplaceOpen,
  // login,
  qrCode,
}) => {
  const { t, i18n } = useTranslation()
  const { getConfig } = useThemeConfig()
  const { getSystemSetting } = useSystemSettings()
  const styles = useStyles()
  const {
    closeMobileMenu,
    mobileMenuOpen,
  } = useMobileMenu()
  const handleCouponMarketplaceOpen = (e) => {
    closeMobileMenu(e)
    onCouponMarketplaceOpen()
  }

  const handleOpenMemberCode = (e) => {
    closeMobileMenu(e)
    onMemberCodeOpen()
  }

  const defaultMenuConfig = [
    {
      id: 'account',
      path: '/account/',
    },
    {
      id: 'orders',
      path: '/account/orders/',
    },
    {
      id: 'myCoupons',
    },
    {
      id: 'memberQrCode',
    },
    {
      id: 'storeCredit',
      path: '/account/store-credit/',
    },
    {
      id: 'favourites',
      path: '/account/favourites/',
    },
    {
      id: 'logout',
      path: '/logout/',
    },
  ]
  const favouritesEnabled = !getSystemSetting('hide_favourites', false)
  const storeCreditEnabled = getSystemSetting('payment_gateway.enable_stored_value', false)
  const menuConfig = _.filter(
    getConfig('config.ui.sideMenu', defaultMenuConfig),
    ({ id }) => {
      if (id === 'favourites') {
        return favouritesEnabled
      }
      if (id === 'storeCredit') {
        return storeCreditEnabled
      }
      if (id === 'memberQrCode') {
        return !_.isEmpty(qrCode)
      }
      return true
    },
  )

  const linkProps = {
    gatsbyLink: true,
    onClick: () => closeMobileMenu(),
  }

  const renderListItem = ({ id, path }) => {
    switch (id) {
      case 'myCoupons':
        return (
          <li
            key={`side_menu_item_${id}`}
            className={combineClassNames([styles.listItem, styles.listCoupon])}
            onClick={(e) => handleCouponMarketplaceOpen(e)}
          >
            <span data-open>{t('ui.header.coupons')}</span>
          </li>
        )
      case 'memberQrCode':
        return (
          <li
            key={`side_menu_item_${id}`}
            className={combineClassNames([styles.listItem, styles.listCoupon])}
            onClick={(e) => handleOpenMemberCode(e)}
          >
            <span data-open>{t('ui.header.member')}</span>
          </li>
        )

      default:
        return (
          <li
            key={`side_menu_item_${id}`}
            className={styles.listItem}
          >
            <Link to={path} {...linkProps}>
              {t(`ui.header.${id}`)}
            </Link>
          </li>
        )
    }
  }

  return (

    <div
      className={combineClassNames([
        styles.container,
        mobileMenuOpen && styles.containerOpen,
      ])}
      data-open
      id="menu-mobile"
    >
      <div className={combineClassNames([
        styles.menuMobile,
        mobileMenuOpen && styles.menuMobileOpen,
      ])}
      >
        <>
          <WithAuth
            isAuth={() => (
              <div className={styles.containerButtons}>
                <Search locale={i18n.language} isOpenSearch className={styles.search} />
                <div className={styles.boxMenu}>
                  <Accordion
                    t={t}
                    onItemClick={closeMobileMenu}
                  />
                  {
                    availableLocales.length > 1 && (
                      <ButtonLanguage
                        onLanguageChange={onLanguageChange}
                        availableLocales={availableLocales}
                        currentLocale={currentLocale}
                      />
                    )
                  }
                  <div className={styles.boxButtons}>
                    <ul className={styles.listMenuAuth}>
                      {
                        _.map(menuConfig, renderListItem)
                      }
                    </ul>
                  </div>
                </div>
              </div>
            )}
            isNotAuth={() => (
              <>
                <div className={styles.containerButtons}>
                  <div className={styles.boxButtons}>
                    <Link to="/login/" {...linkProps}>{t('ui.header.login')}</Link>
                    <Link to="/registration/" {...linkProps}>{t('ui.header.register')}</Link>
                  </div>
                  <Search locale={i18n.language} isOpenSearch className={styles.search} />
                </div>
                <div className={styles.boxMenu}>
                  <Accordion
                    t={t}
                    onItemClick={closeMobileMenu}
                  />
                  {
                    availableLocales.length > 1 && (
                      <ButtonLanguage
                        onLanguageChange={onLanguageChange}
                        availableLocales={availableLocales}
                        currentLocale={currentLocale}
                      />
                    )
                  }
                </div>
              </>
            )}
          />
        </>

      </div>
      <div
        rola="button"
        className={styles.closeMenuTriggerArea}
        onClick={closeMobileMenu}
      />
    </div>
  )
}

export default MenuMobileView
